/* Dobierz do zamowienia (kit-builder) - sklep.jcb-tools.pl
   Kroki w pionie, szyny produktow widoczne od startu, pasek z suma pod krokami.
   Produkt glowny na stale na liscie + wlasny licznik sztuk.
   Kazde wybrane akcesorium ma licznik w wierszu kroku (widoczny takze po zwinieciu).
   Antydubel: czyta /cart.js i dodaje tylko brakujaca roznice sztuk produktu glownego.
   Zaleznosci: pubsub.js i constants.js z theme.liquid. */

if (!customElements.get('kit-builder')) {
  customElements.define(
    'kit-builder',
    class KitBuilder extends HTMLElement {
      connectedCallback() {
        this.tool = {
          id: Number(this.dataset.toolVariantId),
          price: Number(this.dataset.toolPrice),
          available: this.dataset.toolAvailable !== 'false',
        };

        this.toolQty = 1;
        this.toolInCart = 0;
        this.selection = new Map();

        this.ui = {
          total: this.querySelector('[data-kb-total]'),
          count: this.querySelector('[data-kb-count]'),
          progress: this.querySelector('[data-kb-progress]'),
          toolMeta: this.querySelector('[data-kb-tool-meta]'),
          toolTag: this.querySelector('[data-kb-tool-tag]'),
          toolQtyInput: this.querySelector('[data-kb-tool-qty]'),
          toolDown: this.querySelector('[data-kb-tool-down]'),
          ctaText: this.querySelector('[data-kb-cta-text]'),
          error: this.querySelector('[data-kb-error]'),
        };
        this.submitBtn = this.querySelector('[data-kb-submit]');
        this.steps = Array.from(this.querySelectorAll('[data-kb-step]'));

        this.moneyFmt = this.buildFormatter();

        this.bindToolQty();
        this.bindSteps();
        this.bindCards();
        if (this.submitBtn) this.submitBtn.addEventListener('click', () => this.submit());

        if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          this.unsubscribeVariant = subscribe(PUB_SUB_EVENTS.variantChange, (event) => this.onVariantChange(event));
          this.unsubscribeCart = subscribe(PUB_SUB_EVENTS.cartUpdate, () => this.refreshCartState());
        }

        this.render();
        this.refreshCartState();
      }

      disconnectedCallback() {
        if (this.unsubscribeVariant) this.unsubscribeVariant();
        if (this.unsubscribeCart) this.unsubscribeCart();
      }

      buildFormatter() {
        try {
          return new Intl.NumberFormat(this.dataset.locale || 'pl', {
            style: 'currency',
            currency: this.dataset.currency || 'PLN',
          });
        } catch (e) {
          return null;
        }
      }

      money(cents) {
        const value = cents / 100;
        if (this.moneyFmt) return this.moneyFmt.format(value);
        return value.toFixed(2) + ' ' + (this.dataset.currency || 'PLN');
      }

      clamp(input, value) {
        const max = parseInt(input.getAttribute('max'), 10) || 10;
        return Math.min(max, Math.max(1, value || 1));
      }

      /* ---------- licznik produktu glownego ---------- */

      bindToolQty() {
        const input = this.ui.toolQtyInput;
        if (!input) return;

        const up = this.querySelector('[data-kb-tool-up]');
        const down = this.ui.toolDown;

        if (up) up.addEventListener('click', () => this.nudgeToolQty(1));
        if (down) down.addEventListener('click', () => this.nudgeToolQty(-1));

        input.addEventListener('change', () => {
          input.value = this.clamp(input, parseInt(input.value, 10));
          this.toolQty = Number(input.value);
          this.render();
        });
      }

      nudgeToolQty(delta) {
        const input = this.ui.toolQtyInput;
        if (!input) return;
        input.value = this.clamp(input, (parseInt(input.value, 10) || 1) + delta);
        this.toolQty = Number(input.value);
        this.render();
      }

      /* ---------- stan koszyka ---------- */

      refreshCartState() {
        fetch('/cart.js', { headers: { Accept: 'application/json' } })
          .then((response) => response.json())
          .then((cart) => {
            const line = (cart.items || []).find((item) => item.variant_id === this.tool.id);
            this.toolInCart = line ? line.quantity : 0;
            if (this.toolInCart > this.toolQty) {
              this.toolQty = this.toolInCart;
              if (this.ui.toolQtyInput) this.ui.toolQtyInput.value = this.toolQty;
            }
            this.render();
          })
          .catch(() => {
            this.toolInCart = 0;
          });
      }

      /* ---------- kroki: rozwijanie + licznik akcesorium ---------- */

      bindSteps() {
        this.steps.forEach((step) => {
          step.querySelectorAll('[data-kb-toggle]').forEach((btn) => {
            btn.addEventListener('click', () => this.toggleStep(step));
          });

          const input = step.querySelector('[data-kb-qty-input]');
          const up = step.querySelector('[data-kb-qty-up]');
          const down = step.querySelector('[data-kb-qty-down]');

          if (up) up.addEventListener('click', () => this.nudgeStepQty(step, 1));
          if (down) down.addEventListener('click', () => this.nudgeStepQty(step, -1));
          if (input) {
            input.addEventListener('change', () => {
              input.value = this.clamp(input, parseInt(input.value, 10));
              this.setStepQty(step, Number(input.value));
            });
          }
        });
      }

      nudgeStepQty(step, delta) {
        const input = step.querySelector('[data-kb-qty-input]');
        if (!input) return;
        input.value = this.clamp(input, (parseInt(input.value, 10) || 1) + delta);
        this.setStepQty(step, Number(input.value));
      }

      setStepQty(step, qty) {
        const entry = this.selection.get(step.dataset.kbStep);
        if (!entry) return;
        entry.qty = qty;
        this.render();
      }

      toggleStep(step, force) {
        const open = typeof force === 'boolean' ? force : !step.classList.contains('is-open');
        step.classList.toggle('is-open', open);
        const toggle = step.querySelector('.kb__step-toggle');
        if (toggle) toggle.setAttribute('aria-expanded', String(open));
        this.paintChev(step, open);
      }

      paintChev(step, open) {
        const chev = step.querySelector('[data-kb-chev]');
        if (!chev) return;
        chev.textContent = open ? 'Zwiń' : this.selection.has(step.dataset.kbStep) ? 'Zmień' : 'Rozwiń';
      }

      // po wyborze zwijamy krok i otwieramy pierwszy kolejny bez wyboru
      advanceFrom(step) {
        this.toggleStep(step, false);
        const idx = this.steps.indexOf(step);
        for (let i = idx + 1; i < this.steps.length; i += 1) {
          const next = this.steps[i];
          if (this.selection.has(next.dataset.kbStep)) continue;
          this.toggleStep(next, true);
          return;
        }
      }

      /* ---------- karty produktow (tylko wybor) ---------- */

      bindCards() {
        this.querySelectorAll('[data-kb-item]').forEach((card) => {
          card.addEventListener('click', (event) => {
            if (event.target.closest('a')) return;
            this.toggleCard(card);
          });

          card.addEventListener('keydown', (event) => {
            if (event.key !== 'Enter' && event.key !== ' ') return;
            event.preventDefault();
            this.toggleCard(card);
          });
        });
      }

      toggleCard(card) {
        const stepId = card.dataset.step;
        const id = Number(card.dataset.variantId);
        const current = this.selection.get(stepId);
        const step = this.steps.find((s) => s.dataset.kbStep === stepId);

        if (current && current.id === id) {
          this.selection.delete(stepId);
          this.pressStep(stepId);
          this.render();
          if (step) this.toggleStep(step, true);
          return;
        }

        // zmiana produktu w kroku zachowuje ustawiona ilosc
        const keepQty = current ? current.qty : 1;
        this.selection.set(stepId, {
          id: id,
          price: Number(card.dataset.price),
          title: card.dataset.title,
          image: card.dataset.image,
          qty: keepQty,
        });

        if (step) {
          const input = step.querySelector('[data-kb-qty-input]');
          if (input) input.value = this.clamp(input, keepQty);
        }

        this.pressStep(stepId);
        this.render();
        if (step) this.advanceFrom(step);
      }

      pressStep(stepId) {
        const picked = this.selection.get(stepId);
        this.querySelectorAll('[data-kb-item][data-step="' + stepId + '"]').forEach((card) => {
          const isOn = !!picked && picked.id === Number(card.dataset.variantId);
          card.setAttribute('aria-pressed', String(isOn));
          const state = card.querySelector('[data-kb-card-state]');
          if (state) state.textContent = isOn ? 'Dodane' : 'Wybierz';
        });
      }

      /* ---------- wariant produktu glownego ---------- */

      onVariantChange(event) {
        const variant = event && event.data ? event.data.variant : null;
        if (!variant) return;

        this.tool.id = variant.id;
        this.tool.price = variant.price;
        this.tool.available = variant.available !== false;

        if (this.ui.toolMeta) {
          this.ui.toolMeta.textContent = this.money(variant.price) + ' \u00b7 ' + variant.title;
        }

        this.render();
        this.refreshCartState();
      }

      /* ---------- render ---------- */

      toolUnitsToAdd() {
        if (!this.tool.available) return 0;
        return Math.max(0, this.toolQty - this.toolInCart);
      }

      render() {
        const toolUnits = this.toolUnitsToAdd();

        let total = this.tool.price * toolUnits;
        let count = toolUnits;
        let done = 0;

        this.steps.forEach((step) => {
          const stepId = step.dataset.kbStep;
          const entry = this.selection.get(stepId);
          const pick = step.querySelector('[data-kb-pick]');
          const thumb = step.querySelector('[data-kb-thumb]');
          const qtyDown = step.querySelector('[data-kb-qty-down]');
          const isOpen = step.classList.contains('is-open');

          if (entry) {
            done += 1;
            total += entry.price * entry.qty;
            count += entry.qty;

            step.classList.add('is-picked');
            if (pick) {
              pick.textContent =
                entry.title + ' \u00b7 ' + (entry.qty > 1 ? entry.qty + ' \u00d7 ' : '') + this.money(entry.price);
            }
            if (thumb && entry.image) {
              thumb.src = entry.image;
              thumb.alt = '';
            }
            if (qtyDown) qtyDown.disabled = entry.qty <= 1;
          } else {
            step.classList.remove('is-picked');
            if (pick) pick.textContent = step.dataset.emptyLabel || 'Wybierz z listy';
            if (thumb) thumb.removeAttribute('src');
          }

          this.paintChev(step, isOpen);
        });

        if (this.ui.toolTag) {
          if (!this.tool.available) {
            this.ui.toolTag.textContent = 'Niedostępny';
          } else if (this.toolInCart) {
            this.ui.toolTag.textContent = 'W koszyku: ' + this.toolInCart;
          } else if (this.toolQty > 1) {
            this.ui.toolTag.textContent = this.toolQty + ' szt.';
          } else {
            this.ui.toolTag.textContent = 'Ten produkt';
          }
        }
        if (this.ui.toolDown) {
          this.ui.toolDown.disabled = this.toolQty <= Math.max(1, this.toolInCart);
        }

        if (this.ui.total) this.ui.total.textContent = this.money(total);
        if (this.ui.count) {
          this.ui.count.textContent = count ? count + ' ' + this.plural(count) + ' do dodania' : 'Nic do dodania';
        }
        if (this.ui.progress) {
          this.ui.progress.textContent = this.steps.length ? 'Dobrane: ' + done + ' z ' + this.steps.length : '';
        }

        const canSubmit = this.selection.size > 0 || toolUnits > 0;
        if (this.submitBtn) this.submitBtn.disabled = !canSubmit;
        if (this.ui.ctaText) {
          if (!this.tool.available && !this.selection.size) {
            this.ui.ctaText.textContent = 'Wybrany wariant jest niedostępny';
          } else if (!canSubmit) {
            this.ui.ctaText.textContent = 'Wybierz produkty powyżej';
          } else {
            this.ui.ctaText.textContent = 'Dodaj do koszyka (' + count + ')';
          }
        }
      }

      plural(n) {
        if (n === 1) return 'pozycja';
        const last = n % 10;
        const teen = n % 100;
        if (last >= 2 && last <= 4 && (teen < 12 || teen > 14)) return 'pozycje';
        return 'pozycji';
      }

      /* ---------- koszyk ---------- */

      showError(message) {
        if (!this.ui.error) return;
        this.ui.error.textContent = message;
        this.ui.error.style.display = message ? 'block' : 'none';
      }

      submit() {
        const toolUnits = this.toolUnitsToAdd();
        if (!this.selection.size && !toolUnits) return;

        this.showError('');
        this.submitBtn.setAttribute('aria-disabled', 'true');
        this.submitBtn.classList.add('loading');

        const items = [];
        if (toolUnits > 0) items.push({ id: this.tool.id, quantity: toolUnits });
        this.selection.forEach((entry) => items.push({ id: entry.id, quantity: entry.qty }));

        const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        const body = { items: items };

        if (cart && typeof cart.getSectionsToRender === 'function') {
          body.sections = cart.getSectionsToRender().map((section) => section.id).join(',');
          body.sections_url = window.location.pathname;
          if (typeof cart.setActiveElement === 'function') cart.setActiveElement(document.activeElement);
        }

        const url = (window.routes && window.routes.cart_add_url) || '/cart/add';

        fetch(url, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/javascript' },
          body: JSON.stringify(body),
        })
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              this.showError(response.description || response.message || 'Nie udało się dodać produktów do koszyka.');
              if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
                publish(PUB_SUB_EVENTS.cartError, { source: 'kit-builder', errors: response.errors });
              }
              return;
            }

            if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'kit-builder',
                productVariantId: String(this.tool.id),
                cartData: response,
              });
            }

            if (window.dataLayer) {
              window.dataLayer.push({ event: 'kit_builder_add_to_cart', kit_items: items.length });
            }

            if (cart && typeof cart.renderContents === 'function' && response.sections) {
              cart.renderContents(response);
            } else {
              window.location = (window.routes && window.routes.cart_url) || '/cart';
            }

            this.refreshCartState();
          })
          .catch((error) => {
            console.error('[kit-builder]', error);
            this.showError('Wystąpił błąd połączenia. Spróbuj ponownie.');
          })
          .finally(() => {
            this.submitBtn.removeAttribute('aria-disabled');
            this.submitBtn.classList.remove('loading');
            if (cart && cart.classList.contains('is-empty')) cart.classList.remove('is-empty');
          });
      }
    }
  );
}
